import track_promise from "../../utils/track_promise"
import { Engine } from "./Engine"

export const {
  MergePdf,
  PlotPdf,
  RasterizePdf,
  SplitPdf,
  ZipFiles,
  GenerateFile,
  CreateRemoteFile,
} = Engine

export const RequestBlob = f =>
  track_promise(emit => Engine.RequestBlob(f, emit))
